import React, { useEffect } from 'react';
import ContainerCB5 from '../main/ContainerCB5';
import { useQueryClient } from '@cd/react-query';
const FORM_APP_PARAM = 9;

const EditParamFormCB5 = ({ match, onClose, history }) => {
	const queryClient = useQueryClient();
	useEffect(() => {
		return () => {
			onClose();
		};
	});
	return (
		<ContainerCB5
			onSuccess={() => {
				queryClient.invalidateQueries('getAllAppParams');
			}}
			match={match}
			params={match.params}
			formID={FORM_APP_PARAM}
			history={history}
		/>
	);
};

// TODO: put this back params={{ id }}

export default EditParamFormCB5;
